import isAuthenticationError from './is-authentication-error';
import { scaniaAnalyticsApiScopes, SILENT_REDIRECT_URI, msalInstance } from '@/app/msal';

const getApiAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: scaniaAnalyticsApiScopes,
      account: activeAccount,
      redirectUri: SILENT_REDIRECT_URI,
    });

    return response.accessToken;
  } catch (error: unknown) {
    if (isAuthenticationError(error)) {
      return '';
    }

    throw error;
  }
};

export default getApiAccessToken;
